import type Lenis from 'lenis'

interface ScrollToIdOptions {
    focus?: boolean
}

let instance: Lenis | null = null

export const setLenis = (lenis: Lenis | null): void => {
    instance = lenis
}

export const getLenis = (): Lenis | null => instance

export const prefersReducedMotion = (): boolean => {
    if (typeof window === 'undefined') return false

    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

export const scrollToId = (id: string, { focus = false }: ScrollToIdOptions = {}): boolean => {
    if (typeof document === 'undefined') return false

    const target = document.getElementById(id)

    if (!target) return false

    if (instance) instance.scrollTo(target, { duration: 1.3 })
    else target.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' })

    if (focus) {
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1')
        target.focus({ preventScroll: true })
    }

    return true
}

export const lockScroll = (locked: boolean): void => {
    if (typeof document === 'undefined') return

    if (instance) {
        if (locked) instance.stop()
        else instance.start()
    }

    document.documentElement.style.overflow = locked ? 'hidden' : ''
}
